<template>
  <div class="specialists-container">
    <div class="title">科技特派员</div>
    <div class="search-container">
      <input
        v-model="searchKeyword"
        type="text"
        placeholder="按姓名搜索特派员"
        class="search-input"
        @keyup.enter="searchSpecialists"
      >
      <button @click="searchSpecialists" class="search-button">搜索</button>
    </div>
    <div class="scroll-container" ref="scrollContainer">
      <div class="scroll-content" ref="scrollContent">
        <!-- 将特派员信息分成多个2列3行的网格页面 -->
        <div v-for="(page, pageIndex) in specialistPages" :key="pageIndex" class="specialists-grid">
          <div v-for="(specialist, index) in page" :key="index" class="specialist-item" @click="showSpecialistDetail(specialist)">
            <div class="specialist-avatar-container">
  <img v-if="specialist && specialist.avatar" :src="specialist.avatar" alt="" class="specialist-avatar">
  <div v-else class="specialist-avatar-placeholder">
    <i class="el-icon-user"></i>
  </div>
</div>
            <div class="specialist-info">
              <div class="info-row">
                <span class="info-label">姓&emsp;&emsp;名:</span>
                <span class="info-value" v-html="specialist ? (specialist.name.length === 2 ? specialist.name[0] + '&emsp;' + specialist.name[1] : specialist.name) : ''"></span>
              </div>

              <div class="info-row">
                <span class="info-label">职&emsp;&emsp;称:</span>
                <span class="info-value">{{ specialist ? specialist.position : '' }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">服务领域:</span>
                <span class="info-value">{{ specialist ? specialist.serviceField : '' }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">联系方式:</span>
                <span class="info-value">{{ specialist ? specialist.phone : '' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 特派员详情弹窗 -->
    <div v-if="showDetail" class="specialist-detail-overlay" @click="closeDetail">
      <div class="specialist-detail-container" @click.stop>
        <div class="specialist-detail-header">
          <h3>特派员详细信息</h3>
          <button class="close-button" @click="closeDetail">×</button>
        </div>
        <div class="specialist-detail-content">
          <div class="detail-avatar-container">
            <img v-if="selectedSpecialist && selectedSpecialist.avatar" :src="selectedSpecialist.avatar" alt="" class="detail-avatar">
            <div v-else class="detail-avatar-placeholder">
              <i class="el-icon-user"></i>
            </div>
          </div>
          <div class="detail-info">
            <div class="detail-row">
              <span class="detail-label">姓&emsp;&emsp;名:</span>
              <span class="info-value" v-html="selectedSpecialist ? (selectedSpecialist.name.length === 2 ? selectedSpecialist.name[0] + '&emsp;' + selectedSpecialist.name[1] : selectedSpecialist.name) : ''"></span>

            </div>

            <div class="detail-row">
              <span class="detail-label">职&emsp;&emsp;称:</span>
              <span class="detail-value">{{ selectedSpecialist ? selectedSpecialist.position : '' }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">服务领域:</span>
              <span class="detail-value">{{ selectedSpecialist ? selectedSpecialist.serviceField : '' }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">联系方式:</span>
              <span class="detail-value">{{ selectedSpecialist ? selectedSpecialist.phone : '' }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">服务单位:</span>
              <span class="detail-value">{{ selectedSpecialist ? selectedSpecialist.serviceUnit : '未知' }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">工作单位:</span>
              <span class="detail-value">{{ selectedSpecialist ? selectedSpecialist.workUnit : '未知' }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">乡镇街道:</span>
              <span class="detail-value">{{ selectedSpecialist ? selectedSpecialist.administrativeVillage : '未知' }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">类&emsp;&emsp;型:</span>
              <span class="detail-value">{{ selectedSpecialist ? selectedSpecialist.personnelType : '未知' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TechPersonnelController from '../../../api/Controller/TechPersonnelController';
import { uploadMixin } from '@/core/mixins';

export default {
  name: 'Specialists',
  mixins: [uploadMixin],
  props: {
    cityName: {
      type: String,
      default: ''
    },
    cityId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      specialistPages: [],
      scrollTimer: null,
      scrollSpeed: 1, // 滚动速度
      searchKeyword: '', // 搜索关键字
      showDetail: false, // 是否显示详情弹窗
      selectedSpecialist: null // 当前选中的特派员
    }
  },
  mounted () {
    // 根据cityName获取实际的特派员数据
    this.fetchSpecialists();
    this.startScroll();
  },
  beforeDestroy () {
    this.stopScroll();
  },
  methods: {
    // 根据location和关键字获取特派员数据
    fetchSpecialists () {
      const location = this.cityName;
      if (!location) {
        console.warn('没有提供location参数，无法获取特派员数据');
        return;
      }

      console.log('开始获取特派员数据，location:', location, 'keyword:', this.searchKeyword);

      // 构造查询参数
      const params = {
        techPersonnelDtoFilter: {
          townStreet: location, // 以地图名称作为位置查询条件
          searchString: this.searchKeyword // 按姓名搜索
        }
      };

      // 调用API查询特派员信息
      TechPersonnelController.list(this, params).then(res => {
        console.log('特派员信息API返回结果：', res);

        // 处理API返回结果
        let specialistList = [];
        if (res && res.data && res.data.dataList) {
          specialistList = res.data.dataList;
        } else if (res && res.data && res.data.list) {
          specialistList = res.data.list;
        }

        if (specialistList.length > 0) {
          // 将查询结果转换为组件需要的数据格式
          const originalSpecialists = specialistList.map(specialist => {
            // 解析图片数据，参考techPersonnelList.vue的逻辑
            let avatar = require('../../../assets/img/bigScreen/ico_kpt.png');
            if (specialist.imageUrl) {
              try {
                const imageItems = this.parseUploadData(specialist.imageUrl, {id: specialist.id, fieldName: 'imageUrl', asImage: true});
                if (imageItems && imageItems.length > 0) {
                  avatar = imageItems[0].url;
                }
              } catch (e) {
                console.error('解析图片数据失败:', e);
              }
            }

            return {
              ...specialist,
              avatar: avatar,
              name: specialist.expertName || specialist.name || '未知',
              position: specialist.jobGrade || '未知',
              phone: specialist.contactInfo || specialist.phone || '未知',
              originalImageUrl: specialist.imageUrl,
              serviceField: specialist.serviceField,
              affiliation: specialist.affiliation || specialist.unit || '未知',
              expertise: specialist.expertise || specialist.specialty || '未知',
              id: specialist.id
            };
          });

          // 复制数据实现无缝滚动（只在数据量足够时才复制）
          const allSpecialists = originalSpecialists.length > 4 
            ? [...originalSpecialists, ...originalSpecialists] 
            : originalSpecialists;

          // 将特派员数据分成一个页面
          this.specialistPages = [allSpecialists];
          console.log('获取到的特派员数据：', this.specialistPages);
        } else {
          console.warn('没有获取到特派员数据');
          // 如果没有数据，使用默认数据
          this.specialistPages = [[
            {
              avatar: require('../../../assets/img/bigScreen/ico_kpt.png'),
              name: '暂无特派员数据',
              position: '',
              phone: ''
            }
          ]];
        }
      }).catch(err => {
        console.error('获取特派员数据出错：', err);
        // 出错时使用默认数据
        this.specialistPages = [[
          {
            avatar: require('../../../assets/img/bigScreen/ico_kpt.png'),
            name: '获取数据失败',
            position: '',
            phone: ''
          }
        ]];
      });
    },

    // 搜索特派员
    searchSpecialists () {
      // 停止当前滚动
      this.stopScroll();
      // 重新获取数据
      this.fetchSpecialists();
      // 重新开始滚动
      setTimeout(() => {
        this.startScroll();
      }, 100);
    },

    // 显示特派员详情
    showSpecialistDetail (specialist) {
      // 停止滚动
      this.stopScroll();
      // 设置选中的特派员
      this.selectedSpecialist = specialist;
      // 显示详情弹窗
      this.showDetail = true;
    },

    // 关闭详情弹窗
    closeDetail () {
      // 隐藏详情弹窗
      this.showDetail = false;
      // 清空选中的特派员
      this.selectedSpecialist = null;
      // 重新开始滚动
      this.startScroll();
    },
    startScroll () {
      const scrollContainer = this.$refs.scrollContainer
      const scrollContent = this.$refs.scrollContent

      if (!scrollContainer || !scrollContent) return

      this.scrollTimer = setInterval(() => {
        scrollContainer.scrollTop += this.scrollSpeed

        // 当滚动到原始数据的高度时，无缝跳回开头
        // 这样可以实现平滑的无缝滚动
        const originalHeight = scrollContent.scrollHeight / 2;
        if (scrollContainer.scrollTop >= originalHeight) {
          scrollContainer.scrollTop = 0
        }
      }, 30)
    },
    stopScroll () {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer)
        this.scrollTimer = null
      }
    }
  },
  watch: {
    cityName (newVal) {
      if (newVal) {
        this.fetchSpecialists();
      }
    }
  }
}
</script>

<style scoped>
.specialists-container {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
}

.title {
  font-size: 18px;
  font-weight: bold;
  color: #ffd700;
  text-align: center;
  margin-bottom: 15px;
  text-shadow: 2px 2px 4px #2c2c2c, 0 0 10px #ffd700, 0 0 20px #ffd700;
  -webkit-text-stroke: 1px #333;
  //padding: 5px 15px;
}

.search-container {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
  padding: 0 10px;
}

.search-input {
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #c2d4e7;
  border-radius: 4px;
  background: rgba(14, 46, 44, 0.8);
  color: #fff;
  font-size: 14px;
}

.search-input::placeholder {
  color: #aaa;
}

.search-button {
  padding: 0 20px;
  border: 1px solid #c2d4e7;
  border-radius: 4px;
  background: linear-gradient(135deg, rgba(14, 46, 44, 0.95) 0%, rgba(1, 19, 13, 0.95) 100%);
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.search-button:hover {
  background: linear-gradient(135deg, rgba(1, 19, 13, 0.95) 0%, rgba(14, 46, 44, 0.95) 100%);
  transform: translateY(-1px);
}

.scroll-container {
  width: 100%;
  height: calc(100% - 100px);
  overflow-x: hidden;
  overflow-y: auto;
  /* 隐藏滚动条 */
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.scroll-container::-webkit-scrollbar {
  display: none;
}

.scroll-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0;
  width: 100%;
  box-sizing: border-box;
  min-height: 100%;
}

.specialists-grid {
  /* 使用CSS Grid布局，2列 */
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 两列，自适应宽度 */
  gap: 10px; /* 网格间距 */
  width: 100%;
  box-sizing: border-box;
  padding: 0;
  min-height: 100%;
}

.specialist-item {
  /* 每个特派员信息卡片 */
  background: rgba(14, 46, 44, 0.8);
  border: 1px solid #c2d4e7;
  border-radius: 8px;
  padding: 15px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  box-sizing: border-box;
  cursor: pointer;
  transition: all 0.3s ease;
}

.specialist-item:hover {
  background: rgba(14, 46, 44, 0.95);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(1, 185, 183, 0.3);
  border-color: #01b9b7;
}

.specialist-avatar-container {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-right: 15px;
  overflow: hidden;
  border: 2px solid #01b9b7;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(1, 185, 183, 0.1);
}

.specialist-avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.specialist-avatar-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(1, 185, 183, 0.1);
}

.specialist-avatar-placeholder i {
  font-size: 40px;
  color: rgba(1, 185, 183, 0.5);
}

.specialist-info {
  flex: 1;
}

.info-row {
  display: flex;
  margin-bottom: 5px;
}

.info-label {
  font-size: 14px;
  color: #aaa;
  margin-right: 5px;
  min-width: 40px;
}

.info-value {
  font-size: 14px;
  color: #fff;
  font-weight: bold;
}

/* 特派员详情样式 */
.specialist-detail-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.specialist-detail-container {
  background: linear-gradient(135deg, rgba(14, 46, 44, 0.95) 0%, rgba(1, 19, 13, 0.95) 100%);
  border: 1px solid #c2d4e7;
  border-radius: 10px;
  width: 90%;
  max-width: 600px;
  max-height: 80%;
  overflow-y: auto;
  box-shadow: 0 0 30px rgba(1, 185, 183, 0.5);
}

.specialist-detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #c2d4e7;
  background: rgba(1, 19, 13, 0.8);
}

.specialist-detail-header h3 {
  margin: 0;
  color: #ffd700;
  font-size: 18px;
  font-weight: bold;
}

.close-button {
  background: none;
  border: none;
  color: #fff;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.close-button:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: scale(1.1);
}

.specialist-detail-content {
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.detail-avatar-container {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  margin-bottom: 20px;
  overflow: hidden;
  border: 3px solid #01b9b7;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(1, 185, 183, 0.1);
}

.detail-avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.detail-avatar-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(1, 185, 183, 0.1);
}

.detail-avatar-placeholder i {
  font-size: 60px;
  color: rgba(1, 185, 183, 0.5);
}

.detail-info {
  width: 100%;
  max-width: 400px;
}

.detail-row {
  display: flex;
  margin-bottom: 15px;
  padding: 10px;
  background: rgba(1, 19, 13, 0.5);
  border-radius: 6px;
  border: 1px solid rgba(1, 185, 183, 0.2);
}

.detail-label {
  font-size: 16px;
  color: #73DDFF;
  margin-right: 15px;
  min-width: 80px;
  font-weight: bold;
}

.detail-value {
  font-size: 16px;
  color: #fff;
  flex: 1;
}
</style>
